import * as types from '../constants/maildetails'

const initialState={
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  maildetailsList:null,
  maildetails:null,
}

export function mailDetails(state = initialState, action){
  switch (action.type) {
    case types.FETCH_MAIL_REQUEST:
      return {
        ...initialState,
        Status:true
      };
    case types.FETCH_MAIL_REQUEST_COMPLETED:
      return {
        ...state,
        Status:false,
        apiGetResult: true,
        maildetails:action.data
      };
    case types.FETCH_MAIL_REQUEST_ERROR:
      return {
        ...state,
        Status:false,
        apiGetResult: false,
        // maildetailsList:action.error
      };
      case types.FETCH_MAIL_RESET:
        return {
          ...state,
          Status: null,
          apiGetResult: null,
          maildetailsList:null,
          maildetails:null,
        };
    case types.FETCH_MAIL_LIST_REQUEST:
      return {
        ...initialState,
        Status:true
      };
    case types.FETCH_MAIL_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status:false,
        apiGetResult: true,
        maildetailsList:action.data
      };
    case types.FETCH_MAIL_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status:false,
        apiGetResult: false,
        // maildetailsList:action.error
      };
    case types.ADD_MAIL_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_MAIL_REQUEST:
      return {
        ...initialState,
        Status:true
      };
    case types.ADD_MAIL_REQUEST_COMPLETED:
      return {
        ...state,
        Status:false,
        apiPostResult: true
      };
    case types.ADD_MAIL_REQUEST_ERROR:
      return {
        ...state,
        Status:false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/mailDetails.js